import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Layers } from 'lucide-react';
export function PlatformOverview() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" id="platform" data-id="element-1457" data-mp="29ry118qiylkj">
      <div className="text-center mb-16" data-id="element-1458" data-mp="24qijhqnk2x6w">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-1459" data-mp="1zts0ovkd9nhs">
          Platform Structure
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-1460" data-mp="1uvqhmamxxo6b">
          One platform. Multiple layers of development.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-1461" data-mp="1m1c2q96bofnq">
        {/* Card 1: CJI */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="bg-surface-card rounded-lg p-8 lg:p-10 border border-line shadow-premium hover:shadow-premium-hover transition-shadow duration-300 relative overflow-hidden group" data-id="element-1462" data-mp="1h3alzuwdcsff">
          <div className="absolute top-0 left-0 w-full h-1 bg-navy transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-1463" data-mp="e6zckn79ic5r"></div>

          <div className="w-12 h-12 rounded-md bg-surface-muted flex items-center justify-center text-navy mb-8 border border-line" data-id="element-1464" data-mp="16uliw37vjuwb">
            <Activity size={24} strokeWidth={1.5} data-id="element-1465" data-mp="1bs3slvtpue5d" />
          </div>

          <div className="flex items-baseline gap-3 mb-4" data-id="element-1466" data-mp="wwnrx7ymrk00">
            <h3 className="text-2xl font-heading font-bold text-ink-dark" data-id="element-1467" data-mp="wy8ot48f3f11">
              CJI
            </h3>
            <span className="text-sm font-medium text-ink-muted" data-id="element-1468" data-mp="11x249279lg3u">
              Civic Judgment Index
            </span>
          </div>

          <p className="text-ink-muted leading-relaxed text-lg" data-id="element-1469" data-mp="3mlq4x1vnnzal">
            Decision-quality analytics, propaganda-resistance profiling,
            cognitive assessment, and leadership reasoning diagnostics.
          </p>
        </motion.div>

        {/* Card 2: NCJI */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="bg-surface-card rounded-lg p-8 lg:p-10 border border-line shadow-premium hover:shadow-premium-hover transition-shadow duration-300 relative overflow-hidden group" data-id="element-1470" data-mp="1jcxvdbcsvpqp">
          <div className="absolute top-0 left-0 w-full h-1 bg-teal transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-1471" data-mp="vgaa1884ft9q"></div>

          <div className="w-12 h-12 rounded-md bg-surface-muted flex items-center justify-center text-teal mb-8 border border-line" data-id="element-1472" data-mp="2psi1gbl8hs0r">
            <Layers size={24} strokeWidth={1.5} data-id="element-1473" data-mp="2xbrbm71kduqv" />
          </div>

          <div className="flex items-baseline gap-3 mb-4" data-id="element-1474" data-mp="32b3vcix52lp8">
            <h3 className="text-2xl font-heading font-bold text-ink-dark" data-id="element-1475" data-mp="329j00r302yqb">
              NCJI
            </h3>
            <span className="text-sm font-medium text-ink-muted" data-id="element-1476" data-mp="374onvvfyqnh1">
              Neurocognitive Civic Judgment Index
            </span>
          </div>

          <p className="text-ink-muted leading-relaxed text-lg" data-id="element-1477" data-mp="2eeq0s5lbx0f0">
            A broader developmental architecture integrating human opportunity,
            institutional readiness, civic resilience, and executive-level
            leadership evaluation.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="text-center" data-id="element-1478" data-mp="2tbp77q4g2n7w">
        <p className="inline-block px-6 py-3 bg-surface-muted rounded-full text-sm font-medium text-navy-light border border-line" data-id="element-1479" data-mp="66tbf5l1nuvt">
          This is not a static score. It is a progression system.
        </p>
      </motion.div>
    </section>;
}